import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bfa47886"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "employee-schedule-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"120px"} }, "месяц", -1))
const _hoisted_3 = ["onClick", "onContextmenu"]
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { style: {"flex-grow":"3"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, " - ", -1))
const _hoisted_7 = { style: {"flex-grow":"3"} }
const _hoisted_8 = { style: {"text-align":"left"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { extId: "ddl2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_form, null, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_1, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_2,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(31), (_, i) => {
                return (_openBlock(), _createElementBlock("th", {
                  style: {"width":"calc(100% / 31)"},
                  key: i
                }, _toDisplayString(i + 1), 1))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (m, mI) => {
              return (_openBlock(), _createElementBlock("tr", { key: mI }, [
                _createElementVNode("td", null, _toDisplayString(m), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeSchedule[mI], (_, dI) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: dI,
                    class: _normalizeClass({'toggled': !!_?.id, 'disabled': !_ctx.isWorkingDayDisabled(mI, dI)}),
                    onClick: () => _ctx.onToggleScheduleDateClick(mI, dI),
                    onContextmenu: _withModifiers((e) => _ctx.onScheduleDateRightClick(mI, dI, e), ["right"])
                  }, null, 42, _hoisted_3))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.isScheduleAsyncOperationPending]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isScheduleEditDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isScheduleEditDialogVisible) = $event)),
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onExistingScheduledDayUpdateClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isScheduleEditDialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_time_select, {
              modelValue: _ctx.scheduledDate!.scheduledStartTime,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scheduledDate!.scheduledStartTime) = $event)),
              "max-time": _ctx.scheduledDate!.scheduledEndTime,
              placeholder: "Начало смены",
              start: _ctx.sheduledDayMinStartTime,
              step: "00:15",
              end: _ctx.sheduledDayMaxEndTime
            }, null, 8, ["modelValue", "max-time", "start", "end"])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_time_select, {
              modelValue: _ctx.scheduledDate!.scheduledEndTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scheduledDate!.scheduledEndTime) = $event)),
              "min-time": _ctx.scheduledDate!.scheduledStartTime,
              placeholder: "Завершение смены",
              start: _ctx.sheduledDayMinStartTime,
              step: "00:15",
              end: _ctx.sheduledDayMaxEndTime
            }, null, 8, ["modelValue", "min-time", "start", "end"])
          ])
        ]),
        _createTextVNode("   "),
        _createVNode(_component_el_input, {
          modelValue: _ctx.scheduledDate!.notes,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scheduledDate!.notes) = $event)),
          autosize: { minRows: 3, maxRows: 6 },
          type: "textarea",
          maxlength: "5000",
          "show-word-limit": "",
          placeholder: "Комментарии, видны только менеджерам"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dropdown, {
      ref: "dropdown1",
      trigger: "contextmenu"
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, { ref: "dd1" }, {
          default: _withCtx(() => [
            (!!_ctx.scheduledDate?.id)
              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: 0,
                  onClick: _ctx.onDropDownMenuChangeItemClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Изменить смену")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: 1,
                  onClick: _ctx.onDropDownMenuAddItemClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Добавить смену")
                  ]),
                  _: 1
                }, 8, ["onClick"])),
            _createVNode(_component_el_dropdown_item, { disabled: true }, {
              default: _withCtx(() => [
                _createTextVNode("Назначить по шаблону")
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, { onClick: _ctx.onDropDownMenuDeleteItemClick }, {
              default: _withCtx(() => [
                _createTextVNode("Удалить смену")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 512)
      ]),
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    }, 512)
  ], 64))
}